// react
import React, { useMemo, useRef, forwardRef, useImperativeHandle } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

// services
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, convertDate, validateDate, MaskDate } from "beaktShared/helpers/masks";
import { UsePostApi } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoDinheiro.js";
const useStyles = makeStyles(styles);

const PagamentoFinanciamento = forwardRef(function PagamentoFinanciamento({ pgto, CallloadTotalizadorPgtosFinanciamento, formaFinanciamento, loadCarrinho, history, setalert }, ref) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { register, errors, handleSubmit, setValue, getValues } = useForm({ mode: "onBlur" });
  const endPoint = "clientes/";

  const pgtoRef = useRef(pgto);
  pgtoRef.current = pgto;

  const [messageReturn, setmessageReturn] = React.useState({ show: false, message: '' });
  const [LoadingForm, setLoadingForm] = React.useState(false);
  const [botaoLancarPagamento, setBotaoLancarPagamento] = React.useState(false);
  const [drSimEtapaSimular, setDrSimEtapaSimular] = React.useState(false);
  const [drSimEtapaRetornoSimulacao, setDrSimEtapaRetornoSimulacao] = React.useState(false);
  const [drSimSimulacaoRetorno, setDrSimSimulacaoRetorno] = React.useState(null);
  const [atualizarCliente, setAtualizarCliente] = React.useState(false);
  const [dataPrimeiroVencimento, setDataPrimeiroVencimento] = React.useState(null);
  const [valorFinanciado, setValorFinanciado] = React.useState(null);
  const [confirmacaoAceite, setConfirmacaoAceite] = React.useState(false);
  const [totalParcelas, setTotalParcelas] = React.useState(null);

  const ValidaFinanciamento = useMemo(() => {
    setBotaoLancarPagamento(false);
    setDrSimEtapaRetornoSimulacao(false);
    setDrSimSimulacaoRetorno(null);
    setConfirmacaoAceite(false);

    if (pgto?.pagamentos?.length > 0) {
      const temDrSim = pgto.pagamentos.some(p => p.tipo === 4);
      setDrSimEtapaSimular(false);
      if (!temDrSim) {
        setmessageReturn({
          show: true,
          tipo: 'erro',
          message: t('Para pagamentos com a forma selecionada, esta deve ser a primeira forma de pagamento a ser incluída na venda. Após a aprovação do financiamento as demais formas de pagamento poderão ser adicionadas.')
        });
      }
    } else {
      setDrSimEtapaSimular(true);
      setmessageReturn({ show: false });
    }
  }, [pgto?.pagamentos]);

  useImperativeHandle(ref, () => ({
    reset: () => {
      const currentPgto = pgtoRef.current;
      setDrSimEtapaRetornoSimulacao(false);
      setDrSimSimulacaoRetorno(null);
      setBotaoLancarPagamento(false);
      setConfirmacaoAceite(false);
      setDataPrimeiroVencimento(null);
      setValorFinanciado(null);
      setTotalParcelas(null);
      setAtualizarCliente(false);
      setLoadingForm(false);
      setValue("valor", "");
      setValue("totalParcelas", "");
      if (currentPgto?.pagamentos?.length > 0) {
        const temDrSim = currentPgto.pagamentos.some(p => p.tipo === 4);
        setDrSimEtapaSimular(false);
        if (!temDrSim) {
          setmessageReturn({
            show: true,
            tipo: 'erro',
            message: t('Para pagamentos com a forma selecionada, esta deve ser a primeira forma de pagamento a ser incluída na venda. Após a aprovação do financiamento as demais formas de pagamento poderão ser adicionadas.')
          });
        }
      } else {
        setDrSimEtapaSimular(true);
        setmessageReturn({ show: false });
      }
    }
  }), []);

  const handleSimulaParcelamento = () => {
    if (pgto?.pagamentos?.length > 0) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('Para pagamentos com a forma selecionada, esta deve ser a primeira forma de pagamento a ser incluída na venda. Após a aprovação do financiamento as demais formas de pagamento poderão ser adicionadas.')
      });
      setDrSimEtapaSimular(false);
      return;
    }

    setLoadingForm(true);
    setmessageReturn({ show: false });
    setAtualizarCliente(false);
    setDataPrimeiroVencimento(null);
    setValorFinanciado(null);
    setTotalParcelas(null);

    const values = getValues();
    let valor = transformValueFormatedtoFloat(values.valor);
    let dataPrimeiroVencimentoVal = values.dataPrimeiroVencimento;
    let totalParcelasVal = parseInt(values.totalParcelas) || 0;

    if (!valor || valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2)) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });
      setLoadingForm(false);
      return false;
    }

    if (!validateDate(dataPrimeiroVencimentoVal)) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('error_message.invalid_date')
      });
      setLoadingForm(false);
      return false;
    }

    if (!totalParcelasVal || totalParcelasVal <= 0) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('Informe o total de parcelas.')
      });
      setLoadingForm(false);
      return false;
    }

    if (totalParcelasVal <= 1) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('Informe uma valor maior que 1 ao total de parcelas.')
      });
      setLoadingForm(false);
      return false;
    }

    setDataPrimeiroVencimento(dataPrimeiroVencimentoVal);
    setValorFinanciado(valor);
    setTotalParcelas(totalParcelasVal);

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    if (convertDate(dataPrimeiroVencimentoVal) < hoje) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: 'Informe uma data maior que a data de hoje.'
      });
      setLoadingForm(false);
      return false;
    }

    let dataSimulacao = {
      EstabelecimentoId: loadCarrinho?.estabelecimentoId,
      Valor: valor,
      ClienteId: loadCarrinho?.clienteId,
      DataPrimeiroVencimento: dataPrimeiroVencimentoVal,
      TotalParcelas: totalParcelasVal,
    };

    UsePostApi(endPoint + 'clienteSimulacaoDrSim', dataSimulacao).then(result => {
      if (result.status !== 200) {
        setmessageReturn({
          show: true,
          tipo: 'erro',
          message: result?.message
        });
        setLoadingForm(false);
        return false;
      }

      const simulacaoData = result?.data;

      if (!simulacaoData || !simulacaoData.numPayments) {
        setmessageReturn({
          show: true,
          tipo: 'erro',
          message: t('Nenhuma opção de parcelamento foi retornada pela simulação.')
        });
        setLoadingForm(false);
        return false;
      }

      setDrSimSimulacaoRetorno(simulacaoData);
      setDrSimEtapaSimular(false);
      setDrSimEtapaRetornoSimulacao(true);
      setBotaoLancarPagamento(false);

      setLoadingForm(false);
      return true;
    });
  };

  const handleNovaSimulacao = () => {
    setDataPrimeiroVencimento(null);
    setValue("valor", "");
    setValorFinanciado(null);
    setDrSimEtapaSimular(true);
    setDrSimEtapaRetornoSimulacao(false);
    setBotaoLancarPagamento(false);
    setDrSimSimulacaoRetorno(null);
    setAtualizarCliente(false);
    setConfirmacaoAceite(false);
    setTotalParcelas(null);
    sendScrollToTOP();
    setmessageReturn({ show: false });
  };

  const getDataMais30Dias = () => {
    const hoje = new Date();
    hoje.setDate(hoje.getDate() + 30);
    const dia = String(hoje.getDate()).padStart(2, '0');
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const ano = hoje.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const sendScrollToTOP = () => {
    const container = document.querySelector('#divscroll');
    container.scrollTop = 0;
    container.behavior = 'smooth';
  };

  const handleAlterarCliente = () => {
    if (!!history)
      history.push("/adminclinic/identificacaovenda", { origem: "venda" });
  };

  const handleConfirmacaoAceite = (event) => {
    setConfirmacaoAceite(event.target.value === "sim");
    setBotaoLancarPagamento(true);
  };

  const handleCancelDrSim = () => {
    setLoadingForm(false);
    setalert(null);
  };

  const handleConfirmDrSim = async (data, valor, observacao) => {
    let dataPlanoFinanciamento = {
      EstabelecimentoId: loadCarrinho?.estabelecimentoId,
      Valor: valor,
      ClienteId: loadCarrinho?.clienteId,
      DataPrimeiroVencimento: dataPrimeiroVencimento,
      TotalParcelas: totalParcelas,
      DrSimSimulacaoRetorno: drSimSimulacaoRetorno,
    };

    let emprestimoID = '';
    try {
      const result = await UsePostApi(endPoint + 'clienteCriarFinanciamentoDrSim', dataPlanoFinanciamento);
      
      if (result.status !== 200) {
        setmessageReturn({
          show: true,
          tipo: 'erro',
          message: result?.message
        });
        setLoadingForm(false);
        return;
      }

      const emprestimoResponse = result?.data?.emprestimoResponse ?? [];
      emprestimoID = emprestimoResponse?.id;

      setmessageReturn({
        show: true,
        message: (
          <>
            Por favor, clique em <strong>FINALIZAR VENDA</strong> para prosseguir com a análise do empréstimo Dr Sim.
          </>
        )
      });
    } catch (error) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('error_message.api_error')
      });
      setLoadingForm(false);
      return;
    }

    setDrSimEtapaSimular(false);
    setDrSimEtapaRetornoSimulacao(false);
    setBotaoLancarPagamento(false);
    setDrSimSimulacaoRetorno(null);
    sendScrollToTOP();

    finalizarPagamento(data, valor, observacao, emprestimoID);
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    setLoadingForm(true);
    let valor = transformValueFormatedtoFloat(data.valor);
    let observacao = data.observacao || '';

    if (valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2)) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });
      setLoadingForm(false);
      return;
    }

    setmessageReturn({ show: false });

    setalert(
      <SweetAlert
        warning={true}
        title={t('label.attention')}
        showConfirm={true}
        showCancel={true}
        confirmBtnText={t('label.confirm')}
        cancelBtnText={t('button.cancel')}
        cancelBtnBsStyle={"secondary"}
        confirmBtnBsStyle={"danger"}
        onConfirm={() => {
          setalert(null);
          handleConfirmDrSim(data, valor, observacao);
        }}
        onCancel={() => handleCancelDrSim()}
      >
        <span>
          Você deseja prosseguir com o envio de dados para pedido de financiamento DR SIM?
        </span>
        {
          (valor < pgto.totalizadorPagamentos.valorPendente.toFixed(2)) &&
          <>
            <br />
            <span>
              Apenas após o retorno de sucesso, você poderá lançar outra forma de pagamento do valor pendente.
            </span>
          </>
        }
      </SweetAlert>
    );
  };

  const finalizarPagamento = (data, valor, observacao, emprestimoID) => {
    let numParcelas = drSimSimulacaoRetorno?.numPayments ?? 1;
    let descParcelas;
    if (drSimSimulacaoRetorno) {
      let valorParcela = drSimSimulacaoRetorno.monthlyPaymentAmount / 100;
      descParcelas = numParcelas + "x " + transformValueFloattoFormated(valorParcela);
    } else {
      descParcelas = "1 Parcela";
    }

    let pg = {
      id: pgto.pagamentos.length + 1,
      tipo: 4,
      descricaoFormaPgto: 'Dr Sim',
      gateway: formaFinanciamento?.gateway ?? '',
      valor: valor,
      descTipo: 'Dr Sim',
      parcela: numParcelas,
      observacao: observacao,
      descPacela: descParcelas,
      orderId: emprestimoID,
    };

    let updatepgto = {
      ...pgto,
      pagamentos: [
        ...pgto.pagamentos,
        pg
      ]
    };

    setValue("valor", "");
    setLoadingForm(false);
    CallloadTotalizadorPgtosFinanciamento(updatepgto);
  };

  return (
    <div style={{ paddingBottom: '30px' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              {t('label.value')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              defaultValue=""
              name="valor"
              InputProps={{ inputComponent: MaskMoney }}
              inputRef={register({ required: true })}
              error={errors.valor ? true : false}
            />
            <FormHelperText>
              {errors.valor && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>
          </GridItem>
        </GridContainer>

        {
          drSimEtapaSimular &&
          <>
            <GridContainer className={classes.containerin}>
              <GridItem xs={12} sm={3} md={3}>
                <div className={classes.labelIdent}>
                  Primeiro Vencimento *
                </div>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <TextField
                  error={errors.dataPrimeiroVencimento ? true : false}
                  variant="outlined"
                  inputRef={register({ required: false })}
                  name="dataPrimeiroVencimento"
                  defaultValue={getDataMais30Dias()}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    inputComponent: MaskDate,
                  }}
                />
                <FormHelperText>
                  {errors.dataPrimeiroVencimento && <span className="obg">{t('label.required')}</span>}
                </FormHelperText>
              </GridItem>
            </GridContainer>
            <GridContainer className={classes.containerin}>
              <GridItem xs={12} sm={3} md={3}>
                <div className={classes.labelIdent}>
                  Total de Parcelas *
                </div>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
                <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  name="totalParcelas"
                  inputRef={register({ required: true })}
                  error={errors.totalParcelas ? true : false}
                />
                <FormHelperText>
                  {errors.totalParcelas && <span className="obg">{t('label.required')}</span>}
                </FormHelperText>
              </GridItem>
            </GridContainer>
          </>
        }

        <div style={{ paddingTop: '25px', textAlign: 'center' }}>
          <hr className='lineGrayDashed' />
          {
            drSimEtapaSimular &&
            <>
              <GridContainer className={classes.containerin}>
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {LoadingForm ? (
                      <CircularProgress size={30} />
                    ) : (
                      <Button color="primary" onClick={handleSimulaParcelamento}>
                        {t('button.simulate')}
                      </Button>
                    )}
                  </div>
                </GridItem>
                {
                  atualizarCliente &&
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="secondary" onClick={handleAlterarCliente}>
                      {t('button.update_client')}
                    </Button>
                  </GridItem>
                }
              </GridContainer>
              <hr className='lineGrayDashed' />
            </>
          }
          {
            drSimEtapaRetornoSimulacao && drSimSimulacaoRetorno && (
              <>
                <GridContainer className={classes.containerin}>
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.container}>
                      <h3 className={classes.title}>Resultado da Simulação</h3>
                      <p>Valor financiado: <strong>R$ {transformValueFloattoFormated(valorFinanciado)}</strong></p>
                      <p>Primeiro Vencimento: <strong>{dataPrimeiroVencimento}</strong></p>

                      <div className={classes.linha}>
                        <span className={classes.rotulo}>Valor Solicitado:</span>
                        <span className={classes.valor}>
                          R$ {transformValueFloattoFormated(drSimSimulacaoRetorno.requestedAmount / 100)}
                        </span>
                      </div>

                      <div className={classes.linha}>
                        <span className={classes.rotulo}>Total a Pagar:</span>
                        <span className={classes.valor}>
                          R$ {transformValueFloattoFormated(drSimSimulacaoRetorno.totalAmountOwed / 100)}
                        </span>
                      </div>

                      <div className={classes.linha}>
                        <span className={classes.rotulo}>Número de Parcelas:</span>
                        <span className={classes.valor}>{drSimSimulacaoRetorno.numPayments}</span>
                      </div>

                      <div className={classes.linha}>
                        <span className={classes.rotulo}>Valor da Parcela:</span>
                        <span className={classes.valor}>
                          R$ {transformValueFloattoFormated(drSimSimulacaoRetorno.monthlyPaymentAmount / 100)}
                        </span>
                      </div>

                      <div className={classes.linha}>
                        <span className={classes.rotulo}>Juros Mensal:</span>
                        <span className={classes.valor}>
                          {(drSimSimulacaoRetorno.monthlyInterestRate * 100).toFixed(2)}%
                        </span>
                      </div>

                      <div className={classes.linha}>
                        <span className={classes.rotulo}>Juros Anual:</span>
                        <span className={classes.valor}>
                          {(drSimSimulacaoRetorno.annualInterestRate * 100).toFixed(2)}%
                        </span>
                      </div>

                      <div className={classes.linha}>
                        <span className={classes.rotulo}>Valor TAC:</span>
                        <span className={classes.valor}>
                          R$ {transformValueFloattoFormated(drSimSimulacaoRetorno.tacAmount / 100)}
                        </span>
                      </div>

                      <div className={classes.linha}>
                        <span className={classes.rotulo}>Valor IOF:</span>
                        <span className={classes.valor}>
                          R$ {transformValueFloattoFormated(drSimSimulacaoRetorno.iofAmount / 100)}
                        </span>
                      </div>
                    </div>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <Button onClick={handleNovaSimulacao}>
                      {t('button.new_simulation')}
                    </Button>
                  </GridItem>
                </GridContainer>
                <hr className="lineGrayDashed" />
                <GridContainer className={classes.containerin}>
                  <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'left' }}>
                    <h3 className={classes.title}>
                      Ao clicar em "Continuar", você confirma que o paciente concordou com os
                      Termos de Uso e Política de Privacidade da Dr. Sim e autorizou o uso de seus
                      dados com uma instituição parceira via SCR (Sistema de Informação de Crédito)
                      para fins de análise de crédito.
                    </h3>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <RadioGroup
                      value={confirmacaoAceite ? "sim" : ""}
                      onChange={handleConfirmacaoAceite}>
                      <FormControlLabel
                        value="sim"
                        control={<Radio color="primary" />}
                        label="Continuar compartilhamento de dados com Dr Sim"
                      />
                    </RadioGroup>
                  </GridItem>
                </GridContainer>
                <hr className='lineGrayDashed' />
              </>
            )
          }
        </div>

        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={12} md={12}>
            {
              messageReturn.show &&
              <div className={`alertmax ${messageReturn.tipo === 'erro' ? 'alertErrorEx' : 'alertEx'}`}>
                <p>
                  {messageReturn.message}
                </p>
              </div>
            }
          </GridItem>
        </GridContainer>

        {
          botaoLancarPagamento &&
          (
            <GridContainer className={classes.containerin}>
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {LoadingForm ? (
                    <CircularProgress size={30} />
                  ) : (
                    <Button type="submit" color="primary">
                      {t('button.post_payment')}
                    </Button>
                  )}
                </div>
              </GridItem>
            </GridContainer>
          )
        }
      </form>
    </div>
  );
});

export default PagamentoFinanciamento;
